'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = spinner;
function spinner() {
    return {
        scope: {},
        restrict: 'E',
        template: '\n            <svg version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="40px" height="40px" viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve">\n                <path fill="#43A1E2" d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z" transform="rotate(150.989 25 25)">\n                    <animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.9s" repeatCount="indefinite"></animateTransform>\n                </path>\n            </svg>\n        '
    };
}


//////////////////
// WEBPACK FOOTER
// /app/~/angular-ui-block/lib/directives/spinner/spinner.js
// module id = 2581
// module chunks = 38